import * as amplitude from '@amplitude/analytics-browser';
import { useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { clientEnvVars } from './common/environment/clientEnvVars';
import { AuthContext } from './features/login/AuthWrapper';

const useAnalytics = () => {
  const auth = useContext(AuthContext);
  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    if (clientEnvVars()?.ANALYTICS_API_TOKEN) {
      amplitude.init(clientEnvVars().ANALYTICS_API_TOKEN, {
        transport: 'beacon',
        flushIntervalMillis: 1000,
        flushMaxRetries: 5,
        flushQueueSize: 30,
      });
    }
  }, [clientEnvVars()?.ANALYTICS_API_TOKEN]);

  const logEvent = (eventName: string, properties?: Record<string, any>) => {
    const userId = auth?.id?.toString();
    const eventProperties = {
      ...properties,
      userId,
      applicationId: id,
    };
    amplitude.track(eventName, eventProperties, {
      // User IDs must be strings with a length of 5 characters or more
      user_id: `user_${userId}`,
      productId: id,
    });
    if (properties?.flush) {
      amplitude.flush();
    }
  };

  return { logEvent };
};

export default useAnalytics;
